import axios from "axios";
import { BASE_URL } from "./api";

export async function getContingencyPayments(token, queryParams){
    return axios({
        method: 'get',
        url: `${BASE_URL}/contingency_payments${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error
    });
}

export async function updateContingencyPayment(token, contingencyPaymentId, data){
    return axios({
        method: 'put',
        url: `${BASE_URL}/contingency_payments/${contingencyPaymentId}/`,
        headers: {
            'Authorization': `Token ${token}`
        },
        data: data
    }).then((response) => {
        return response;
    }).catch((error) => {
        return error
    });
}